module.exports = __webpack_public_path__ + "static/index/img/baikal-1011.d9c61063.jpg";